import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import styles from './Layout.scss'
import { CTA } from 'common/styleguide/CTA'
import { Icon } from 'common/Icon'
import { PopoverLinkMenu, PopoverLinkMenuItem as MenuItem } from 'common/styleguide/PopoverLinkMenu'
import _ from 'lodash'

const NavLink = (props) => (
  <li key={props.to}>
    <Link {...props} activeClassName={styles.active}>{props.children}</Link>
  </li>
)

export class LayoutTop extends React.Component {
  constructor (props) {
    super(props)

    this._throttledOnResize = _.throttle(this.onResize, 100)
    this.state = {
      navItemsToShow: undefined,
      expandNav: false
    }
  }

  componentDidMount () {
    this.cacheNavItemWidths()
    this.computeLayout()
    window.addEventListener('resize', this._throttledOnResize)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this._throttledOnResize)
  }

  onResize = () => {
    this.computeLayout()
  }

  cacheNavItemWidths () {
    this._navItemWidths = []
    this._navListRef.childNodes.forEach(node => {
      this._navItemWidths.push(node.clientWidth)
    })
  }

  computeLayout () {
    const computedStyle = window.getComputedStyle(this._navListRef)
    const padding = parseFloat(computedStyle.paddingLeft) +
                    parseFloat(computedStyle.paddingRight)
    const availableWidth = this._navListRef.clientWidth - padding
    let testWidth = 0
    let navItemsToShow = 0
    this._navItemWidths.forEach(width => {
      testWidth += width
      if (testWidth < availableWidth) {
        navItemsToShow++
      }
    })
    if (navItemsToShow < this._navItemWidths.length) {
      navItemsToShow--
    }
    this.setState({ navItemsToShow })
  }

  toggleNav = () => {
    this.setState({ expandNav: !this.state.expandNav })
  }

  render () {
    const {
      legacy,
      organization,
      canManageMembers,
      showMessages,
      showRoutes,
      showEmbedLibrary,
      showExperiences,
      showCollections,
      showPoiLibrary,
      showBackups,
      isClubAccount,
      currentMember,
      showSettings
    } = this.props
    const { navItemsToShow, expandNav } = this.state
    const idParam = this.props.params.clubIdParam
    const pagePath = page => `/organizations/${idParam}/${page}`
    const legacyPage = page => ({
      [legacy ? 'to' : 'href']: pagePath(page)
    })
    const corePage = page => ({
      [legacy ? 'href' : 'to']: pagePath(page)
    })
    const isActiveMember = currentMember && currentMember.approved_at && currentMember.active
    const showSignIntoClub = isActiveMember && currentMember.manages_routes
    const showSignOut = isClubAccount
    const showApplyToJoin = !isClubAccount && !currentMember && !organization.inviteOnly
    const clubOrOrganizationString = organization.organizationType === 'club' ? 'Club' : 'Organization'

    const navItems = [{ ...legacyPage('home'), label: 'Home' }]
    if (organization.calendarEnabled) {
      navItems.push({ key: 'events', ...legacyPage('events'), label: 'Events' })
    }
    if (showRoutes) {
      navItems.push({ key: 'routes', ...legacyPage('routes'), label: 'Route Library' })
    }
    if (showCollections) {
      navItems.push({ key: 'collections', ...corePage('collections'), label: 'Collections' })
    }
    if (showPoiLibrary) {
      navItems.push({ key: 'poi_library', ...legacyPage('poi_library'), label: 'POI Library' })
    }
    if (showEmbedLibrary) {
      navItems.push({ key: 'embed_library', ...legacyPage('embed_library'), label: 'Embed Library' })
    }
    if (showExperiences) {
      navItems.push({ key: 'experiences', ...legacyPage('experiences'), label: 'Experiences' })
    }
    if (canManageMembers) {
      navItems.push({ key: 'members', ...legacyPage('members'), label: 'Members' })
    }
    if (showMessages) {
      navItems.push({ key: 'messages', ...legacyPage('messages'), label: 'Messages' })
    }
    if (showSettings) {
      navItems.push({ key: 'settings', href: `/organizations/${organization.id}/settings/account`, label: 'Manage Account' })
    }
    if (showBackups) {
      navItems.push({ key: 'backups', href: pagePath('backups'), label: 'Backups' })
    }
    if (showSignOut) {
      navItems.push({ key: 'logout', href: '/logout', label: 'Sign out' })
    }
    const visibleNavItems = navItems.slice(0, navItemsToShow)
    const expandedNavItems = navItems.slice(navItemsToShow)

    return (
      <div className={styles.LayoutTop}>
        <div className={styles.header}>
          <div className={styles.headerInner} style={{ backgroundImage: `url(${organization.get('cover')})` }}>
            <div className={styles.headerGradient} />
            <div className={styles.nameAndSubhead}>
              <div className={styles.name}>{organization.get('name')}</div>
              <div className={styles.subhead}>{organization.get('subhead')}</div>
            </div>
          </div>
        </div>
        <div className={styles.nav}>
          <div className={styles.navInner}>
            <img className={styles.logo} src={organization.get('logo')} />
            <div className={styles.navGroups}>
              <ul ref={ref => { this._navListRef = ref }}>
                {visibleNavItems.map(({ label, ...props }) => <NavLink key={label} {...props}>{label}</NavLink>)}
                {expandedNavItems.length > 0 && <li key='more'><a href='javascript:;' ref={r => { this._more = r }} onClick={this.toggleNav}>More <Icon i='ios-arrow-down' /></a></li>}
              </ul>
              {expandNav && <PopoverLinkMenu
                container={window.body}
                target={this._more}
                placement='bottom'
                onRequestClose={this.toggleNav}>
                {expandedNavItems.map(({ label, ...props }) => <MenuItem key={label} {...props}>{label}</MenuItem>)}
              </PopoverLinkMenu>}
              <div className={styles.actionsContainer}>
                {showSignIntoClub &&
                  <form method='post' action={`/organizations/${organization.id}/sign_in`}>
                    <CTA button inline type='submit' className={styles.navCTA}>Sign into {clubOrOrganizationString}</CTA>
                  </form>}
                {showApplyToJoin && <CTA inline className={styles.navCTA} href={`/auto_approve?apply_to_club_id=${organization.id}`}>Apply to Join</CTA>}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const _Layout = ({ children, params, organization }) => {
  const preloadParams = _.get(window, 'rwgps.clubs.show')
  return (
    <div className={styles.Layout}>
      <LayoutTop legacy params={params} organization={organization} {...preloadParams} />
      <div className={styles.contentWrapper}>
        <div className={styles.content}>
          {children}
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    organization: state.organization,
    currentUser: state.currentUser
  }
}

export const Layout = connect(
  mapStateToProps,
  {}
)(_Layout)
